module.exports = __webpack_public_path__ + "img/025-jew.9f3b7ec4.png";